import { request } from '../utils/request';
import { bpmnApi } from '../config/urlConfig';

/**
 * 通过领域code查询流程
 * @param data
 */
export const pageWorkflow = (data: { page: number; limit: number; domainModelCode: string; params: { process: {}; }; }) =>
  request({
    url: `${bpmnApi}/workflow/design/pageWorkflow`,
    method: 'POST',
    data
  });
